import { useRouter } from "next/router";

export const useChangeLocale = () => {
  const router = useRouter();
  const { pathname, asPath, query } = router;

  return async (newLocale: string) => {
    await router.replace({ pathname, query }, asPath, {
      locale: newLocale,
    });
  };
};
